import {
  ReviewCategory,
  ReviewRating,
} from '@models';
import {
  ReviewFeed,
  UserReviewsFeed,
  UserReviewsFeedSkeleton,
} from '@components/UserReviewsFeed';

import { useUserReviewsFeedQuery } from './gql/graphql.v3.generated';

interface Props {
  className?: string,
  rating?: ReviewRating,
  category?: ReviewCategory,
  username: string,
}

export const UserReviewsFeedContainer: React.FC<Props> = ({
  rating,
  category,
  username,
  className,
}) => {
  const {
    data,
    loading,
    fetchMore,
  } = useUserReviewsFeedQuery({
    variables: {
      rating,
      category,
      username,
      first: 32,
    },
    fetchPolicy: 'cache-and-network',
  });

  const handleLoadMore = async () => {
    const pageInfo = data?.user?.reviews?.pageInfo;

    if (pageInfo?.hasNextPage) {
      await fetchMore({ variables: { after: pageInfo.endCursor } });
    }
  };

  if (loading) {
    return (
      <UserReviewsFeedSkeleton
        className={className}
        count={5}
      />
    );
  }

  if (data?.user?.reviews) {
    const reviews: ReviewFeed[] = data.user.reviews.edges.map(
      (edge) => {
        const node = edge!.node!;

        return {
          id: node.id,
          product: node.product,
          authorUsername: node.owner.username,
          authorAvatarUrl: node.owner.thumbnail,
          authorShopName: node.owner.shopName,
          text: node.text,
          overallRating: node.overallRating,
          createdAt: node.createdAt,
        };
      },
    );

    return (
      <UserReviewsFeed
        className={className}
        reviews={reviews}
        onLoadMore={handleLoadMore}
      />
    );
  }

  return null;
};
